
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardboard-recycling",
      function () {
        return require("private-next-pages/cardboard-recycling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardboard-recycling"])
      });
    }
  